var React = require('react');

function FailureIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.12 1.377l.961.962-.379.38-.964-.963-.962.963-.38-.38.963-.962L.396.413l.38-.38.962.963.964-.962.38.38z","fill":"#c6c6c6"}));
}

FailureIcon.defaultProps = {"width":"13","height":"10.312","viewBox":"0 0 3.44 2.728"};

module.exports = FailureIcon;

FailureIcon.default = FailureIcon;
